/**
 * Language Switcher
 * Handles custom dropdown for language selection
 */

import { setCookie, getCookie } from '../utils/cookie.js';

export function initLangSwitcher() {
	const switchers = document.querySelectorAll('.lang-switcher');
	if (switchers.length === 0) return;

	switchers.forEach((switcher) => {
		const btn = switcher.querySelector('.lang-switcher-btn');
		const dropdown = switcher.querySelector('.lang-dropdown');
		const options = switcher.querySelectorAll('.lang-option');
		const caretIcon = btn.querySelector('.fi-rr-caret-down');

		// Restore language from cookie on page load
		const savedLang = getCookie('selected_lang');
		if (savedLang) {
			const savedOption = Array.from(options).find(
				(opt) => opt.dataset.lang === savedLang,
			);
			if (savedOption) {
				const savedFlag = savedOption.querySelector('img').src;
				const savedText = savedOption.querySelector('span').textContent;

				btn.dataset.selected = savedLang;
				btn.querySelector('.lang-flag').src = savedFlag;
				btn.querySelector('.lang-code').textContent = savedText;
			}
		} else if (btn.dataset.selected) {
			setCookie('selected_lang', btn.dataset.selected);
		}

		// Toggle dropdown
		btn.addEventListener('click', (e) => {
			e.preventDefault();
			e.stopPropagation();

			const isHidden = dropdown.classList.contains('hidden');

			// Close all other dropdowns on the page
			document.querySelectorAll('.lang-dropdown').forEach((d) => d.classList.add('hidden'));
			document.querySelectorAll('.lang-switcher-btn i').forEach((i) => i.classList.remove('rotate-180'));

			if (isHidden) {
				dropdown.classList.remove('hidden');
				caretIcon.classList.add('rotate-180');
			}
		});

		// Close dropdown when clicking outside
		document.addEventListener('click', (e) => {
			if (!switcher.contains(e.target)) {
				dropdown.classList.add('hidden');
				caretIcon.classList.remove('rotate-180');
			}
		});

		// Handle language selection
		options.forEach((option) => {
			option.addEventListener('click', (e) => {
				e.stopPropagation();

				const selectedLang = option.dataset.lang;
				// Save to cookie
				setCookie('selected_lang', selectedLang);

				// Update all buttons on the page to stay in sync
				switchers.forEach((s) => {
					const sBtn = s.querySelector('.lang-switcher-btn');
					const sOption = Array.from(s.querySelectorAll('.lang-option')).find(
						(opt) => opt.dataset.lang === selectedLang,
					);
					if (sOption) {
						sBtn.dataset.selected = selectedLang;
						sBtn.querySelector('.lang-flag').src = sOption.querySelector('img').src;
						sBtn.querySelector('.lang-code').textContent = sOption.querySelector('span').textContent;
					}
					s.querySelector('.lang-dropdown').classList.add('hidden');
					s.querySelector('.fi-rr-caret-down').classList.remove('rotate-180');
				});

				// Dispatch custom event for language change
				const langChangeEvent = new CustomEvent('languageChanged', {
					detail: { language: selectedLang },
				});
				document.dispatchEvent(langChangeEvent);

				// Reload page to apply new language (no ?lang= in URL)
				window.location.reload();
			});
		});
	});
}
